import React, { useEffect, useRef } from 'react';
import { CircularProgress, MenuItem } from '@mui/material';

const AppLoadingMoreMenuItem: React.FC<IAppLoadMoreMenuItem> = ({ loadMore }) => {
    const loadingRef = useRef<HTMLLIElement>(null);

    useEffect(() => {
        const element = loadingRef.current;
        if (!element) return;

        const observer = new IntersectionObserver(
            (entries, obs) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && entry.intersectionRatio === 1) {
                        loadMore();
                        obs.unobserve(entry.target);
                    }
                });
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 1.0,
            },
        );

        observer.observe(element);
        return () => observer.disconnect();
    }, [loadMore]);

    return (
        <MenuItem ref={loadingRef} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CircularProgress size={20} />
        </MenuItem>
    );
};

export { AppLoadingMoreMenuItem };
